import { render, staticRenderFns } from "./standAlone.vue?vue&type=template&id=4b1624df&scoped=true"
import script from "./standAlone.vue?vue&type=script&lang=js"
export * from "./standAlone.vue?vue&type=script&lang=js"
import style0 from "./standAlone.vue?vue&type=style&index=0&id=4b1624df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1624df",
  null
  
)

export default component.exports